import axiosInstance from './api.service';
import constants from '../constants/constants';

const ENDPOINTORIGIN = 'ai/documents';

const list = () =>
    axiosInstance.get(ENDPOINTORIGIN, constants.REQUIRE_INTERCEPTORS);

const getById = (id) =>
    axiosInstance.get(`${ENDPOINTORIGIN}/${id}`, constants.REQUIRE_INTERCEPTORS);

const getResource = (id) =>
    axiosInstance.get(`${ENDPOINTORIGIN}/${id}/resource`, { ...constants.REQUIRE_INTERCEPTORS, responseType: 'blob' });

const getResourceByUrl = (resourceUrl) => {
    const apiPathMatch = typeof resourceUrl === 'string' ? resourceUrl.trim().match(/^\/?api\/(.+)$/i) : null;
    if (!apiPathMatch) return Promise.reject(new Error('The document resource URL is unavailable.'));

    return axiosInstance.get(apiPathMatch[1], { ...constants.REQUIRE_INTERCEPTORS, responseType: 'blob' });
};

const upload = (formData) => {
    return axiosInstance.post(ENDPOINTORIGIN + '/upload', formData, { ...constants.REQUIRE_INTERCEPTORS, fileHandler: true });
};

const reindex = (id) =>
    axiosInstance.post(`${ENDPOINTORIGIN}/${id}/reindex`, {}, constants.REQUIRE_INTERCEPTORS);

const remove = (id) =>
    axiosInstance.delete(`${ENDPOINTORIGIN}/${id}`, constants.REQUIRE_INTERCEPTORS);

export { list, getById, getResource, getResourceByUrl, upload, reindex, remove };
